import renderLogoutModal from "infrastructure/renders/logoutModal/renderLogoutModal";

export default function showLogoutModal(props?) {
  renderLogoutModal(props);
}
